/// <amd-module name="DistributedTaskUI/ServiceEndpoints/Editor/UIContributions/AzureRMEndpoint/Components/Common/WIFFooterLinks" />
import React = require("react");
import { EndpointsEditorPanelUtils } from "DistributedTaskUI/ServiceEndpoints/Editor/Utils/EndpointsEditorPanelUtils";
import { FooterLinks } from "./FooterLinks";

export function WIFFooterLinks(): JSX.Element {
    return (<FooterLinks
        learnMoreLink={EndpointsEditorPanelUtils.AZURE_RM_WORKLOAD_IDENTITY_FEDERATION_LEARN_MORE_LINK}
        troubleShootlink={EndpointsEditorPanelUtils.AZURE_RM_WORKLOAD_IDENTITY_FEDERATION_TROUBLESHOOT_LINK} />);
}